import { Image, StyleSheet, Text, View } from '@react-pdf/renderer'
import React from 'react'
import logoDustre from '../../assets/Cert/logo-dustre-cert.png';

const styles = StyleSheet.create({
  header: {
    position: 'absolute',
    top: 20,
    left: 40,
    right: 40,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    borderBottomWidth: 2,
    borderBottomColor: '#000',
    paddingTop: 10,
    paddingBottom: 10,
    minHeight: 50,
  },
  logoContainer: {
    alignItems: 'flex-start',
  },
  logo: {
    width: 100,
    height: 40,
    objectFit: 'contain',
  },
  logoSubtitle: {
    fontSize: 10,
    marginTop: 2,
    color: '#000',
    paddingLeft: 10,
  },
  headerContact: {
    textAlign: 'right',
  },
  email: {
    fontSize: 9,
    marginTop: 28,
    color: '#000',
  },
  contact: {
    fontSize: 9,
    color: '#000',
  },
})


const HeaderOfPDF = () => {
  return (
    <View fixed style={styles.header} >
      <View style={styles.logoContainer}>
        <Image src={logoDustre} style={styles.logo} />
        <Text style={styles.logoSubtitle}>Aços e Ligas Especiais</Text>
      </View>
      <View style={styles.headerContact}>
        <Text style={styles.email}>E-mail: qualidade@dustre.com.br</Text>
        <Text style={styles.contact}>Tel.: (11) 4556-0929 | Cel.: (11) 96165-6555</Text>
      </View>
    </View>
  )
}

export default HeaderOfPDF